import React, {
  useEffect,
  useState,
} from "react";

import {
  Container,
  Card,
  Row,
  Col,
  Form,
} from "react-bootstrap";

import {
  useParams,
  Link,
  useNavigate,
} from "react-router-dom";

import { useDispatch } from "react-redux";

import { getQuotation, editQuotation } from "../../store/slices/quotation";

import EditQuotationHotelStep from "./quotationHotelStep";
import EditQuotationActivityStep from "./quotationactivityStep";
import EditQuotationCarStep from "./quotationCarStep";
import EditQuotationFerryStep from "./quotationFerryStep";

import PackageStepper from "./PackageStepper";

const steps = [
  "Summary",
  "Hotel",
  "Activity",
  "Car",
  "Ferry",
];

export default function EditQuotation() {
  const { id } =
    useParams();
  console.log(id)
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const [loading, setLoading] =
    useState(false);

  const [currentStep, setCurrentStep] =
    useState(0);

  const [quotation, setQuotation] =
    useState(null);


  const [form, setForm] = useState({
    travelDate: "",
    numberOfAdults: 2,
    numberOfChildren: 0,
    notes: "",
    status: "draft",
  });


  const [hotels, setHotels] =
    useState([]);

  const [activities,
    setActivities] = useState([]);

  const [vehicles, setVehicles] =
    useState([]);

  const [ferries, setFerries] =
    useState([]);

  const [pricingConfig,
    setPricingConfig] = useState({
      markupType: "fixed",
      markupValue: 0,
      gstPercentage: 0,
    });

  useEffect(() => {
    fetchQuotation();
  }, []);



  const fetchQuotation =
    async () => {
      try {
        const item = { id }
        const res =
          await dispatch(
            getQuotation(
              item
            )
          ).unwrap();

        const quotationData =
          Array.isArray(res?.data)
            ? res.data[0]
            : res?.data;

        if (!quotationData) return;

        setQuotation(quotationData);

        console.log(
          "LOADED ACTIVITIES",
          quotationData?.options?.flatMap(
            opt =>
              opt?.itinerarySnapshot?.activities || []
          )
        );
        setForm({
          travelDate:
            quotationData?.travelDate
              ? new Date(
                quotationData.travelDate
              )
                .toISOString()
                .split("T")[0]
              : "",

          numberOfAdults:
            quotationData?.numberOfAdults || 2,

          numberOfChildren:
            quotationData?.numberOfChildren || 0,

          notes:
            quotationData?.notes || "",

          status:
            quotationData?.status || "draft",
        });


        const allHotels =
          quotationData?.options
            ?.flatMap((opt) =>

              (opt?.itinerarySnapshot
                ?.hotels || []).map(
                  (hotel) => ({

                    ...hotel,

                    packageOptionName:
                      opt?.packageOption
                        ?.name ||

                      "Option",

                  })
                )
            ) || [];

        setHotels(allHotels);

        const allActivities =
          quotationData?.options
            ?.flatMap((opt) =>

              (opt
                ?.itinerarySnapshot
                ?.activities || []).map(
                  (activityConfig) => ({

                    ...activityConfig,

                    packageOptionName:
                      opt?.packageOption
                        ?.name ||

                      "Option",

                    activities:
                      activityConfig.activities?.map(
                        (act) => ({

                          ...act,

                          activity:
                            act.activity?._id ||
                            act.activity,

                          vendor:
                            act.vendor?._id ||
                            act.vendor,

                          price:
                            act.price || 0,

                        })
                      ) || [],

                  })
                )
            ) || [];

        setActivities(
          allActivities
        );


        const allFerries =
          quotationData?.options
            ?.flatMap((opt) =>

              (opt
                ?.itinerarySnapshot
                ?.ferries || []).map(
                  (ferryConfig) => ({

                    ...ferryConfig,

                    packageOptionName:
                      opt?.packageOption
                        ?.name ||

                      "Option",

                    ferry:
                      ferryConfig.ferry?._id ||
                      ferryConfig.ferry,

                    ferryClass:
                      ferryConfig.ferryClass?._id ||
                      ferryConfig.ferryClass,

                    from:
                      ferryConfig.from?._id ||
                      ferryConfig.from,

                    to:
                      ferryConfig.to?._id ||
                      ferryConfig.to,

                    price:
                      ferryConfig.price || 0,

                  })
                )
            ) || [];

        setFerries(
          allFerries
        );

        const allVehicles =
          quotationData?.options
            ?.flatMap((opt) =>

              (opt
                ?.itinerarySnapshot
                ?.vehicles || []).map(
                  (vehicleConfig) => ({

                    ...vehicleConfig,

                    packageOptionName:
                      opt?.packageOption
                        ?.name ||

                      "Option",

                    vehicle:
                      vehicleConfig.vehicle?._id ||
                      vehicleConfig.vehicle,

                    vehicleType:
                      vehicleConfig.vehicleType?._id ||
                      vehicleConfig.vehicleType,

                    price:
                      vehicleConfig.price || 0,

                  })
                )
            ) || [];

        setVehicles(
          allVehicles
        );

        const firstOption =
          quotationData?.options?.[0];

        if (firstOption?.pricingBreakup) {

          setPricingConfig({
            markupType:
              firstOption.pricingBreakup
                .markupType || "fixed",

            markupValue:
              firstOption.pricingBreakup
                .markupValue || 0,

            gstPercentage:
              firstOption.pricingBreakup
                .gstPercentage || 0,
          });
        }



      } catch (err) {

        console.error(err);

      }
    };

  const handleChange = (
    field,
    value
  ) => {
    setForm((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSave =
    async () => {

      try {

        setLoading(true);

        for (
          const option of
          quotation.options
        ) {

          const packageOptionId =
            option.packageOption
              ?._id ||
            option.packageOption;

          const optionHotels =
            hotels.filter(
              (h) =>
                String(
                  h.packageOption
                ) ===
                String(
                  packageOptionId
                )
            );

          const optionActivities =
            activities.filter(
              (a) =>
                String(
                  a.packageOption
                ) ===
                String(
                  packageOptionId
                )
            );

          const optionVehicles =
            vehicles.filter(
              (v) =>
                String(
                  v.packageOption
                ) ===
                String(
                  packageOptionId
                )
            );

          const optionFerries =
            ferries.filter(
              (f) =>
                String(
                  f.packageOption
                ) ===
                String(
                  packageOptionId
                )
            );

          const payload = {

            quotationId: id,

            optionId:
              option._id,

            travelDate:
              form.travelDate,

            numberOfAdults:
              form.numberOfAdults,

            numberOfChildren:
              form.numberOfChildren,

            notes:
              form.notes,

            status:
              form.status,

            hotels:
              optionHotels,

            activities:
              optionActivities,

            vehicles:
              optionVehicles,

            ferries:
              optionFerries,

            pricingConfig,
          };

          await dispatch(
            editQuotation(
              payload
            )
          ).unwrap();
        }

        alert(
          "Quotation updated successfully"
        );

        navigate(-1);

      } catch (err) {

        console.error(err);

        alert(
          err?.message ||
          "Failed to update quotation"
        );

      } finally {

        setLoading(false);

      }
    };


  return (
    <>

      <div className="breadcrumb-bar mb-2">

        <div className="breadcrumb-left">

          <Link
            to="/admin/home"
            className="breadcrumb-link active"
          >
            Home
          </Link>

          <span className="breadcrumb-separator">
            |
          </span>

          <Link
            onClick={() => navigate(-1)}
            className="breadcrumb-link active"
          >
            Leads
          </Link>

          <span className="breadcrumb-separator">
            |
          </span>

          <span className="breadcrumb-link inactive">
            Edit Quotation
          </span>

        </div>

      </div>


      <PackageStepper
        steps={steps}
        currentStep={currentStep}
        setCurrentStep={
          setCurrentStep
        }
        isEditable={true}
      />

      <Container fluid>

        {currentStep === 0 && (
          <Card className="p-4">

            <Row>

              <Col md={3}>

                <Form.Label>
                  Travel Date
                </Form.Label>

                <Form.Control
                  type="date"
                  value={
                    form.travelDate
                  }
                  onChange={(e) =>
                    handleChange(
                      "travelDate",
                      e.target.value
                    )
                  }
                />

              </Col>

              {/* ADULTS */}

              <Col md={2}>

                <Form.Label>
                  Adults
                </Form.Label>

                <Form.Control
                  type="text"
                  min={1}
                  value={
                    form.numberOfAdults
                  } readonly="true"
                  onChange={(e) =>
                    handleChange(
                      "numberOfAdults",
                      Number(
                        e.target.value
                      )
                    )
                  }
                />

              </Col>

              {/* CHILDREN */}

              <Col md={2}>

                <Form.Label>
                  Children
                </Form.Label>

                <Form.Control
                  type="text"
                  min={0}
                  value={
                    form.numberOfChildren
                  }
                  readonly="true"
                  onChange={(e) =>
                    handleChange(
                      "numberOfChildren",
                      Number(
                        e.target.value
                      )
                    )
                  }
                />

              </Col>

              {/* STATUS */}



              {/* NOTES */}

              <Col md={12}
                className="mt-3"
              >

                <Form.Label>
                  Notes
                </Form.Label>

                <Form.Control
                  as="textarea"
                  rows={4}
                  value={form.notes}
                  onChange={(e) =>
                    handleChange(
                      "notes",
                      e.target.value
                    )
                  }
                />

              </Col>

            </Row>

            <div
              className="d-flex justify-content-end mt-4"
            >

              <button
                className="submit-btn"
                onClick={() =>
                  setCurrentStep(1)
                }
              >
                Next
              </button>

            </div>

          </Card>
        )}


        {currentStep === 1 && (
          <EditQuotationHotelStep
            hotels={hotels}
            setHotels={setHotels}
            nextStep={() =>
              setCurrentStep(2)
            }
            prevStep={() =>
              setCurrentStep(0)
            }
            isQuotationEdit={true}
          />
        )}

        {currentStep === 2 && (
          <EditQuotationActivityStep
            activities={activities}
            setActivities={
              setActivities
            }
            nextStep={() =>
              setCurrentStep(3)
            }
            prevStep={() =>
              setCurrentStep(1)
            }
          />
        )}


        {currentStep === 3 && (
          <EditQuotationCarStep
            cars={vehicles}
            setCars={setVehicles}
            nextStep={() =>
              setCurrentStep(4)
            }
            prevStep={() =>
              setCurrentStep(2)
            }
          />
        )}


        {currentStep === 4 && (
          <EditQuotationFerryStep
            ferries={ferries}
            setFerries={
              setFerries
            }
            nextStep={() =>
              setCurrentStep(5)
            }
            prevStep={() =>
              setCurrentStep(3)
            }
          />
        )}



        <div
          className="d-flex justify-content-end gap-2 mt-4 mb-3 me-2"
        >

          <button
            className="cancel-btn"
            onClick={() =>
              navigate(-1)
            }
          >
            Cancel
          </button>

          <button
            className="submit-btn"
            onClick={handleSave}
            disabled={loading}
          >
            {loading
              ? "Saving..."
              : "Save"}
          </button>

        </div>

      </Container>
    </>
  );
}
